import * as React from 'react';

function ActDl(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 128 128"
            {...props}
        >
            <path
                d="M78.33,10.31H49.66a5.09,5.09,0,0,0-5.09,5.09V49.16H31a5.1,5.1,0,0,0-3.6,8.7l33,33a5.09,5.09,0,0,0,7.2,0l33-33a5.1,5.1,0,0,0-3.6-8.7H83.42V15.4A5.09,5.09,0,0,0,78.33,10.31ZM102.84,118H25.16a6.5,6.5,0,0,1-6.49-6.49h0A6.5,6.5,0,0,1,25.16,105h77.68a6.5,6.5,0,0,1,6.49,6.49h0A6.5,6.5,0,0,1,102.84,118Z"
                fill="currentColor"
            />
        </svg>
    );
}

export default ActDl;
